import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import upload from '../Res/Icon/Upload.png';
import deleteUpload from '../Res/Icon/file-delete.png';

function CustomDropzone(props) {

    const { files = [], onFileChange, allowOnce = true, show = true } = props;
    const visiblity = allowOnce ? !files?.length > 0 : true

    const onDrop = useCallback((acceptedFiles, file = null) => {
        const currentFiles = Array.isArray(files) ? files : []; 
        let filesList = [];

        if (file && file.path) {
            const filteredFiles = currentFiles.filter(obj => obj.path !== file.path);
            filesList = [...filteredFiles, ...acceptedFiles];
        } else {
            filesList = [...acceptedFiles, ...currentFiles];
        }
    
        onFileChange(filesList);
    }, [files]);
    
    
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                {
                    // if you want to change drop message
                    // isDragActive ?
                    //   <p>Drop the files here ...</p> :
                    <div>

                        {
                            visiblity && show &&
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ flexDirection: 'column' }}
                            >
                                <img className="upload-icon" src={upload} alt="..." />
                                <p>
                                    Drag and drop PDF or Word file here or{' '}
                                    <span style={{ color: '#3b5aa9', fontWeight: '600' }}>Upload</span>
                                </p>
                            </div>
                        }
                    </div>
                }
            </div>

            {files.length > 0 && (
                <div className='d-flex flex-wrap' >
                    {files.map((file, idx) => (
                        <span key={`${file.name}`} className=' m-1' style={{ width: 100 }}>
                            <img className="upload-icon" style={{ zIndex: 10 }} src={deleteUpload} alt="..."
                                onClick={() => {
                                    console.log('this is deletedcall ', file.name);
                                    onDrop('', file);
                                }}
                            />
                            <h2 className='text-overflow-elipsis m-0'>{file.name}</h2>
                        </span>
                    ))}
                </div>

            )}

        </>
    )
}
export default CustomDropzone;